import React, { useState, useEffect } from 'react';

// ==========================================
// 1. INLINE SVG ICONS (Lightweight, Custom)
// ==========================================

const LinkedinIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path fillRule="evenodd" d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z" clipRule="evenodd"/>
  </svg>
);

const GithubIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path fillRule="evenodd" d="M12 0C5.373 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" clipRule="evenodd"/>
  </svg>
);

const YouTubeIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
  </svg>
);

const WhatsappIcon = () => (
  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
    <path d="M.057 24l1.687-6.163c-1.041-1.804-1.588-3.849-1.587-5.946C.06 5.348 5.397.01 12.008.01c3.202.001 6.212 1.246 8.477 3.514 2.266 2.268 3.507 5.28 3.505 8.484-.004 6.657-5.34 11.997-11.953 11.997-2.005-.001-3.973-.502-5.731-1.456L0 24zm6.59-4.846c1.6.95 3.188 1.449 4.825 1.451 5.436 0 9.859-4.42 9.862-9.859.002-2.636-1.023-5.115-2.887-6.98-1.864-1.865-4.343-2.888-6.977-2.889-5.442 0-9.866 4.42-9.869 9.86-.001 1.736.46 3.431 1.332 4.937l-.991 3.623 3.705-.937zm13.626-8.291c-.296-.148-1.753-.866-2.024-.964-.271-.099-.468-.148-.666.148-.198.296-.764.964-.937 1.162-.172.198-.344.223-.64.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.297-.347.446-.521.15-.173.2-.297.3-.495.099-.198.05-.371-.025-.52-.075-.148-.666-1.607-.912-2.199-.24-.578-.484-.499-.666-.508-.172-.007-.37-.01-.567-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.626.712.226 1.36.194 1.872.118.571-.085 1.753-.717 2.0-.14 1.25-.494 2.053-.854 2.102-.94.048-.086.048-.16.024-.21-.024-.049-.198-.148-.495-.296z"/>
  </svg>
);

const MenuIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
  </svg>
);

const CloseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
  </svg>
);

const DownloadIcon = () => (
  <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
  </svg>
);

const ChevronUpIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
  </svg>
);

const ChevronLeftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
  </svg>
);

const ChevronRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
  </svg>
);

const AwardIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-cyber-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
  </svg>
);

const ShieldCheckIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-cyber-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);

const SunIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-amber-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 9H3m15.364-3.364l-.707.707M6.343 17.657l-.707.707m0-12.728l.707.707m12.728 12.728l.707.707M12 8a4 4 0 100 8 4 4 0 000-8z" />
  </svg>
);

const MoonIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-indigo-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
  </svg>
);

const BriefcaseIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-cyber-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
  </svg>
);

const AcademicCapIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 text-cyber-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222" />
  </svg>
);

const MapPinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5 inline mr-1 text-cyber-secondary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
  </svg>
);

// ==========================================
// 2. RESUME DATA
// ==========================================

const portfolioData = {
    name: "Shivam Chudasama",
    title: "Software Engineer",
    subtitle: "Robotics, Full Stack & Android",
    social: {
        linkedin: "https://www.linkedin.com/in/shivam-chudasama-b154232a7/",
        github: "https://github.com/shivcc/",
        youtube: "https://www.youtube.com/@shivamchudasama08"
    },
    about: {
        description: "Versatile Full-Stack Engineer & Robotics Specialist with hands-on experience as a Startup Founder and CTO. Adept at engineering robust software architectures, including enterprise SaaS platforms (Node.js/React) and native mobile applications (Kotlin/Firebase), as well as autonomous robotics stacks (ROS 2/NAV2). A rare blend of deep technical execution—ranging from cloud infrastructure to hardware-level integration—and entrepreneurial leadership focused on automating businesses and solving real-world market challenges.",
        contact: {
            name: "Shivam Chudasama",
            location1: "Dar es Salaam, Tanzania",
            location2: "Kuala Lumpur, Malaysia",
            phone: "+255 685813713",
            email: "shivamchudasama08@gmail.com"
        },
        resumeUrl: "/misc/Shivam Chudasama - Versatile Software Engineer Resume.pdf",
        profilePic: "/images/Shiv_Profile_Pic.jpg",
    },
    resume: {
        education: [
            {
                university: "De Montfort University",
                degree: "M.Eng in Mechatronics and Robotics (Hons)",
                date: "09/2018 – 03/2024",
                description: "Studied robot kinematics, computer vision, automated control, and artificial intelligence. Built strong technical execution capabilities and worked on autonomous ground vehicle prototypes for environmental applications."
            },
            {
                university: "Asia Pacific University of Technology and Innovation (APU)",
                degree: "B.Eng in Mechatronics Engineering (Hons)",
                date: "09/2018 - 03/2024",
                description: "Based in Kuala Lumpur. Focused on microcontroller hardware integration, sensor networking, and control engineering. Developed a real-time Sign Language Translator utilizing deep learning (CNN-LSTM) and computer vision on Android for my Final Year Project."
            }
        ],
        work: [
            {
                company: "AfriMenu (Software)",
                title: "Startup Founder and CTO",
                date: "01/2026 - Current",
                location: "Dar es Salaam, Tanzania",
                description: "Delivering SAAS solutions to optimized restaurant businesses in the Tanzanian market, overcoming tech-adoption challenges. Engineered the full-stack architecture using Node.js/React, secured with authentication services, integrated automated SMS & email APIs, and integrated hardware receipt systems."
            },
            {
                company: "Shivo Gold (Jewelry)",
                title: "Business Owner",
                date: "04/2026 - Current",
                location: "Dar es Salaam, Tanzania",
                description: "Achieved full store and business automation by developing and deploying Accord, a custom Android ERP application that structures inventory, restock alerts, sales recordings, and live financial analysis."
            },
            {
                company: "Mkeka Collection Jewelry",
                title: "Business Partner and Manager",
                date: "04/2024 – Current",
                location: "Dar es Salaam, Tanzania",
                description: "Directing business development operations, covering product sourcing, talent recruitment, marketing campaigns, accounting ledgers, compliance, and calculated risk taking."
            },
            {
                company: "LSANG Communications SDN BHD",
                title: "Repair Technician (Internship)",
                date: "12/2021 - 04/2022",
                location: "Kuala Lumpur, Malaysia",
                description: "Serviced power supplies, amplifiers, and diverse electronic units for high-rise buildings (MATV, CCTV, Fiber & ELV systems). Managed stock catalogs and trained incoming technical staff."
            }
        ],
        skills: {
            programming: {
                title: "Programming",
                color: "from-cyan-500 to-blue-500",
                textColor: "text-cyan-400",
                items: ["C++", "Python", "Java", "Arduino", "Javascript", "Kotlin"]
            },
            fullstack: {
                title: "Full Stack & Cloud",
                color: "from-purple-500 to-indigo-500",
                textColor: "text-purple-400",
                items: ["React", "Node.js", "MongoDB", "Clerk", "Firebase", "AWS"]
            },
            robotics: {
                title: "Robotics & Simulation",
                color: "from-emerald-500 to-teal-500",
                textColor: "text-emerald-400",
                items: ["ROS", "ROS 2", "NAV2 stack", "SLAM", "Sensor Fusion", "Gazebo"]
            },
            hardware: {
                title: "Hardware & Tools",
                color: "from-amber-500 to-orange-500",
                textColor: "text-amber-400",
                items: ["Raspberry Pi", "ESP32", "LIDAR", "TensorFlow", "OpenCV", "Linux"]
            },
            platforms: {
                title: "Platforms & CAD",
                color: "from-pink-500 to-rose-500",
                textColor: "text-pink-400",
                items: ["Android", "AWS Cloud Services", "Solidworks", "MATLAB", "LabVIEW"]
            }
        }
    },
    portfolio: [
        { 
            id: "modal-02", 
            title: "AfriMenu SaaS", 
            category: "Full Stack SaaS", 
            imageUrl: "/images/portfolio/afrimenu.png", 
            tags: ["React", "Node.js", "Firebase", "APIs"],
            type: "fullstack",
            modal: {
                videos: [
                    { src: "https://www.youtube.com/embed/ww8mt7ZSA3k", title: "Software Walkthrough" },
                    { src: "https://www.youtube.com/embed/RgthNkwxL4s", title: "Customer POV Experience" }
                ],
                title: "AfriMenu - Full Stack Restaurant SaaS Platform",
                description: "A robust SaaS suite optimized for restaurant operations, supporting digital ordering, real-time inventory management, employee scheduling, and customer data tracking. Crafted with a React frontend, Node.js backend, SMS/email alert APIs, and specialized receipt-printing hardware integrations.",
                category: "Full Stack Software, Dar es Salaam",
                link: "https://github.com/shivcc/"
            }
        },
        { 
            id: "modal-03", 
            title: "Accord ERP", 
            category: "Android Application", 
            imageUrl: "/images/portfolio/accord.png", 
            tags: ["Kotlin", "Android", "Firebase"],
            type: "mobile",
            modal: {
                images: ["/images/portfolio/accord.png"], 
                title: "Accord - Android Business Automation App",
                description: "A custom ERP application engineered in Kotlin with a Firebase backend to automate jewelry boutique tasks. Automates live inventory counts, restocking reminders, sales ledgers, customer receipt dispatches, and accounting metrics. Actively running at Shivo Gold.",
                category: "Android Mobile App",
                link: "https://github.com/shivcc/"
            }
        },
        { 
            id: "modal-00", 
            title: "Akerbot AMR", 
            category: "Autonomous SLAM Robot", 
            imageUrl: "/images/portfolio/Akerbot.jpg", 
            tags: ["ROS 2", "NAV2", "SLAM", "LiDAR", "IMU"],
            type: "robotics",
            modal: {
                images: ["/images/portfolio/modals/first_map.png", "/images/portfolio/modals/urdf.png"], 
                title: "Akerbot - Akerman Drive Simultaneous Localization and Mapping (SLAM) AMR",
                description: "An autonomous mobile robot designed for mapping environments and navigating around hazards. Infuses IMU, encoders, and LiDAR sensor metrics. Driven by Raspberry Pi & Arduino over serial communication protocols utilizing ROS 2 and the NAV2 stack.",
                category: "Akerbot Autonomous vehicle, Dar es Salaam",
                link: "https://www.linkedin.com/in/shivam-chudasama-b154232a7/"
            }
        },
        { 
            id: "modal-08", 
            title: "Akerbot_Sim", 
            category: "Gazebo Simulation", 
            imageUrl: "/images/gazebo_c.png",
            tags: ["ROS 2", "Gazebo", "URDF", "C++"],
            type: "robotics",
            modal: {
                images: ["/images/gazebo.png"],
                title: "Akerbot_Sim: Gazebo Physical World Simulation",
                description: "Physically simulated Ackerman robot inside Gazebo. Runs customized differential controllers, LIDAR mesh, and sensor physics parameters, serving as a rapid virtual testbed before deploying software to the physical robot chassis.",
                category: "ROS2, Gazebo, Simulation",
                link: "https://www.linkedin.com/in/shivam-chudasama-b154232a7/"
            }
        },
        { 
            id: "modal-09", 
            title: "Trajectory Wiz", 
            category: "ROS Path Visualizer", 
            imageUrl: "/images/traj_wiz.png",
            tags: ["Python", "ROS", "RViz", "UI"],
            type: "robotics",
            modal: {
                video: { src: "https://www.youtube.com/embed/hnT2y9fYaKw", type: "youtube" },
                title: "Trajectory Wiz: Path Visualizer & Recorder",
                description: "A ROS utility software that visualizes, records, saves, and plays back complex robot trajectories in RViz. Eases path analysis and speeds up navigation debugging.",
                category: "ROS, Rviz, Python",
                link: "https://app.theconstruct.ai/l/68fc0c77/"
            }
        },
        { 
            id: "modal-10", 
            title: "Behavior Tree Visualizer", 
            category: "ROS Utility", 
            imageUrl: "/images/bt_visualizer_pkg-Cover.jpg",
            tags: ["ROS 2", "Behavior Trees", "Python"],
            type: "robotics",
            modal: {
                video: { src: "https://www.youtube.com/embed/-g4iD0wkshw", type: "youtube" },
                title: "Behavior Tree Visualizer Package",
                description: "A ROS 2 diagnostic dashboard tool designed to parse and animate Nav2 Behavior Tree states (Active, Success, Failure) in real-time, making robot decision flow debugging interactive.",
                category: "ROS2, Nav2, Python",
                link: "https://github.com/shivcc/bt_visualizer_pkg" 
            }
        },
        { 
            id: "modal-11", 
            title: "TurtleBot Navigation", 
            category: "Path Planning Project", 
            imageUrl: "/images/0410-Cover.jpg",
            tags: ["ROS", "SLAM", "Navigation", "C++"],
            type: "robotics",
            modal: {
                video: { src: "https://www.youtube.com/embed/ZjizE3dDdtE", type: "youtube" },
                title: "TurtleBot Nav - Complete Navigation Stack",
                description: "Implements SLAM mapping, localization, and path planning on a TurtleBot. Saves spatial landmarks dynamically and enables autonomous navigation back to spots via web calls.",
                category: "ROS, SLAM, Navigation",
                link: "https://github.com/shivcc/Ros2-Navigation-in-5-days"
            }
        },
        { 
            id: "modal-01", 
            title: "Agricultural UGV", 
            category: "Autonomous Hardware", 
            imageUrl: "/images/portfolio/UGV.jpg", 
            tags: ["ESP32", "LoRaWAN", "Solidworks", "GPS"],
            type: "robotics",
            modal: {
                video: { src: "/video/video_robot.mp4", type: "video/mp4" },
                title: "UGV for Agricultural Fertilization",
                description: "Designed and fabricated a robust, remote-controlled 4WD UGV prototype to aid palm plantations in fertilizing crops. Incorporates LoRaWAN long-range communication, GPS coordinates, ESP32 microcontrollers, and live video streaming. Achieved a 30% reduction in field labor.",
                category: "Mechatronics Project, Kuala Lumpur",
                link: "https://github.com/shivcc/"
            }
        },
        { 
            id: "modal-05", 
            title: "Sign Language Translator", 
            category: "AI & Deep Learning", 
            imageUrl: "/images/portfolio/MSL.png", 
            tags: ["TensorFlow", "MediaPipe", "Kotlin", "CUDA"],
            type: "mobile",
            modal: {
                video: { src: "/video/MSLA.mp4", type: "video/mp4" },
                title: "Android Real-Time Sign Language Translator",
                description: "Created an Android app translating sign language in real-time. Gathered clean custom datasets, trained a high-accuracy CNN-LSTM network utilizing CUDA acceleration, and compiled the engine on mobile utilizing TensorFlow Lite and Google MediaPipe.",
                category: "AI / Mobile Application",
                link: "https://github.com/shivcc/"
            }
        },
        { 
            id: "modal-06", 
            title: "Smart Hospital Room", 
            category: "IoT System (MTE Silver)", 
            imageUrl: "/images/portfolio/SHE.jpg", 
            tags: ["IoT", "Sensors", "Node.js", "BEM"],
            type: "fullstack",
            modal: {
                images: ["/images/portfolio/modals/m-SHE.png"], 
                title: "Smart Hospital Environment IoT Suite",
                description: "A collaborative smart patient ward concept. Interfaces body biometric telemetry (pulse, temperature) with ambient climate sensors and central node dashboards, letting patients direct room elements over network calls.",
                category: "IoT, APU, Kuala Lumpur",
                link: "https://youtu.be/iBL0YWFAOzI?feature=shared"
            }
        },
    ],
    achievements: [
        {
            title: "Silver Prize Winner",
            event: "Malaysia Technology Expo™ (MTE)",
            project: "Smart Hospital Environment",
            date: "03/2022 - 07/2022",
            description: "Co-developed an integrated IoT ward network linking patient health sensors to a control app, earning the Silver prize in international competition.",
            link: "https://youtu.be/iBL0YWFAOzI?feature=shared"
        }
    ],
    certifications: [
        {
            title: "ROS2 Navigation",
            provider: "The Construct",
            verifyUrl: "https://app.theconstruct.ai/accomplishments/verify/RIA2B9B4ABDCE4B"
        },
        {
            title: "ROS Basics in 5 Days (C++)",
            provider: "The Construct",
            verifyUrl: "https://app.theconstruct.ai/accomplishments/verify/RIA25E7C52344B9"
        },
        {
            title: "ROS Basics in 5 Days (Python)",
            provider: "The Construct",
            verifyUrl: "https://app.theconstruct.ai/accomplishments/verify/RIAAD97A8122F3B"
        }
    ],
    affiliations: [
        {
            title: "Member, Graduate Engineer",
            org: "Board of Engineers Malaysia (BEM)",
            id: "BEM-Ref"
        },
        {
            title: "Member, Engineer",
            org: "Institution of Mechanical Engineers (IMechE)",
            id: "IMechE-Ref"
        }
    ],
    testimonials: [
        {
            text: "Shivam's an extremely talented individual, who has a knack for thinking in creative and out-of-the-box ways that have always amazed me in my five years of knowing him. He's dedicated, honest and hardworking and possesses incredible drive to do better and an extremely wide variety of skills to back that. If there's anyone who's looking for an individual that's creative, technologically sound and hard-working, he's the right person!",
            author: "Rohit Udhwani, Colleague",
            link: "https://www.linkedin.com/feed/update/urn:li:activity:7155715692837621760/"
        }
    ],
    contact: {
        email: "shivamchudasama08@gmail.com",
        phone: "+255685813713",
        whatsapp: "https://wa.me/255685813713"
    }
};

// ==========================================
// 3. COMPONENTS
// ==========================================

const Header = ({ onNavClick, page, darkMode, setDarkMode }) => {
    const [isOpen, setIsOpen] = useState(false);
    const navItems = ["Home", "About", "Experience", "Skills", "Works", "Credentials", "Contact"];

    return (
        <header className="bg-white/80 dark:bg-cyber-950/80 backdrop-blur-md sticky top-0 z-40 text-slate-800 dark:text-white border-b border-slate-200 dark:border-cyber-800 transition-colors duration-300">
            <div className="container mx-auto px-6 py-4 flex justify-between items-center">
                <a href="#home" onClick={(e) => { e.preventDefault(); onNavClick('home'); }} className="text-xl font-extrabold tracking-tight hover:text-cyber-primary transition duration-300 flex items-center gap-2">
                    <span className="w-3 h-3 bg-cyber-primary rounded-full animate-pulse"></span>
                    {portfolioData.name}
                </a>
                
                <div className="hidden md:flex items-center space-x-4">
                    {navItems.map(item => (
                        <a key={item} href={`#${item.toLowerCase()}`} onClick={(e) => { e.preventDefault(); onNavClick(item.toLowerCase()); }} className={`py-2 px-4 rounded-lg text-sm font-semibold transition duration-300 ${page === item.toLowerCase() ? 'bg-cyber-primary text-white shadow-md shadow-cyber-glow' : 'hover:bg-slate-100 dark:hover:bg-cyber-800 text-slate-600 dark:text-slate-300 hover:text-cyber-primary'}`}>
                            {item}
                        </a>
                    ))}
                    
                    {/* Theme Toggle Button */}
                    <button 
                        onClick={() => setDarkMode(!darkMode)} 
                        className="p-2 rounded-lg bg-slate-100 dark:bg-cyber-800 hover:bg-slate-200 dark:hover:bg-cyber-700 transition"
                        title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
                    >
                        {darkMode ? <SunIcon /> : <MoonIcon />}
                    </button>
                </div>
                
                {/* Mobile Header Buttons */}
                <div className="flex items-center gap-2 md:hidden">
                    <button 
                        onClick={() => setDarkMode(!darkMode)} 
                        className="p-2 rounded-lg bg-slate-100 dark:bg-cyber-800 hover:bg-slate-200 dark:hover:bg-cyber-700 transition"
                    >
                        {darkMode ? <SunIcon /> : <MoonIcon />}
                    </button>
                    <button onClick={() => setIsOpen(!isOpen)} className="p-2 text-slate-600 dark:text-slate-200 hover:text-cyber-primary focus:outline-none">
                       {isOpen ? <CloseIcon /> : <MenuIcon />}
                    </button>
                </div>
            </div>
            {/* Mobile Menu */}
            <div className={`md:hidden ${isOpen ? 'block' : 'hidden'} bg-slate-50 dark:bg-cyber-900 border-b border-slate-200 dark:border-cyber-800 transition-colors duration-300`}>
                <div className="px-4 pt-2 pb-6 space-y-2">
                    {navItems.map(item => (
                         <a key={item} href={`#${item.toLowerCase()}`} onClick={(e) => { e.preventDefault(); onNavClick(item.toLowerCase()); setIsOpen(false); }} className={`block py-2.5 px-4 rounded-lg text-base font-semibold transition duration-300 ${page === item.toLowerCase() ? 'bg-cyber-primary text-white' : 'text-slate-600 dark:text-slate-300 hover:bg-slate-150 dark:hover:bg-cyber-800'}`}>
                            {item}
                        </a>
                    ))}
                </div>
            </div>
        </header>
    );
};

const HeroSection = ({ onNavClick }) => (
    <section id="home" className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
        {/* Background Mesh Gradients */}
        <div className="absolute inset-0 bg-slate-50 dark:bg-cyber-950 transition-colors duration-300"></div>
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-cyber-primary/20 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-cyber-accent/20 rounded-full blur-3xl animate-pulse-slow"></div>
        <div className="absolute inset-0 bg-cover bg-center opacity-10 dark:opacity-[0.15] mix-blend-overlay pointer-events-none" style={{ backgroundImage: "url('/images/header-background.jpg')" }}></div>
        
        <div className="relative z-10 text-center px-6 max-w-4xl">
            <span className="inline-block px-4 py-1.5 rounded-full bg-cyber-primary/10 border border-cyber-primary/30 text-cyber-primary font-bold text-xs uppercase tracking-widest mb-6 animate-float">
                Available for New Projects
            </span>
            <h1 className="text-5xl md:text-8xl font-black mb-6 tracking-tight text-slate-800 dark:text-white leading-none">
                {portfolioData.name}
            </h1>
            <h2 className="text-xl md:text-3xl font-light text-slate-600 dark:text-slate-300 mb-4 max-w-2xl mx-auto">
                <span className="font-extrabold text-slate-800 dark:text-white">{portfolioData.title}</span>
            </h2>
            <p className="text-lg md:text-xl font-medium text-cyber-primary dark:text-cyber-primary mb-10 tracking-wide uppercase">
                {portfolioData.subtitle}
            </p>
            
            <div className="flex flex-col sm:flex-row justify-center items-center gap-4">
                <a href="#about" onClick={(e) => { e.preventDefault(); onNavClick('about'); }} className="w-full sm:w-auto px-8 py-4 bg-cyber-primary hover:bg-cyber-primary/95 text-white font-bold rounded-xl shadow-lg shadow-cyber-primary/20 hover:shadow-cyber-primary/30 transition transform hover:-translate-y-0.5 text-center">
                    Discover My Work
                </a>
                <a href="#contact" onClick={(e) => { e.preventDefault(); onNavClick('contact'); }} className="w-full sm:w-auto px-8 py-4 bg-transparent border border-slate-300 dark:border-cyber-800 text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-cyber-800 font-bold rounded-xl transition text-center">
                    Let's Connect
                </a>
            </div>
            
            {/* Social Icons */}
            <div className="flex justify-center space-x-6 mt-16">
                <a href={portfolioData.social.linkedin} target="_blank" rel="noopener noreferrer" className="p-3 bg-white dark:bg-cyber-900 border border-slate-200 dark:border-cyber-800 text-slate-600 dark:text-slate-400 hover:text-cyber-primary hover:border-cyber-primary hover:shadow-lg dark:hover:bg-cyber-850 rounded-xl transition-all duration-300 transform hover:-translate-y-1">
                    <LinkedinIcon />
                </a>
                 <a href={portfolioData.social.github} target="_blank" rel="noopener noreferrer" className="p-3 bg-white dark:bg-cyber-900 border border-slate-200 dark:border-cyber-800 text-slate-600 dark:text-slate-400 hover:text-cyber-primary hover:border-cyber-primary hover:shadow-lg dark:hover:bg-cyber-850 rounded-xl transition-all duration-300 transform hover:-translate-y-1">
                    <GithubIcon />
                </a>
                <a href={portfolioData.social.youtube} target="_blank" rel="noopener noreferrer" className="p-3 bg-white dark:bg-cyber-900 border border-slate-200 dark:border-cyber-800 text-slate-600 dark:text-slate-400 hover:text-cyber-primary hover:border-cyber-primary hover:shadow-lg dark:hover:bg-cyber-850 rounded-xl transition-all duration-300 transform hover:-translate-y-1">
                    <YouTubeIcon />
                </a>
            </div>
        </div>
    </section>
);

const AboutSection = () => (
    <section id="about" className="py-24 bg-slate-50 dark:bg-cyber-900 transition-colors duration-300">
        <div className="container mx-auto px-6">
            <h2 className="text-4xl md:text-5xl font-black text-center mb-16 text-slate-800 dark:text-white">
                About Me
            </h2>
            <div className="flex flex-col lg:flex-row items-center gap-16">
                <div className="w-full lg:w-1/3 flex-shrink-0 flex justify-center">
                    <div className="relative group">
                        <div className="absolute inset-0 bg-gradient-to-tr from-cyber-primary to-cyber-accent rounded-3xl blur-xl opacity-30 group-hover:opacity-50 transition duration-500"></div>
                        <div className="relative border border-slate-200 dark:border-cyber-800 bg-white dark:bg-cyber-850 p-4 rounded-3xl transition-transform duration-300 group-hover:scale-[1.02]">
                            <img className="rounded-2xl shadow-2xl w-64 h-64 md:w-80 md:h-80 object-cover" src={portfolioData.about.profilePic} alt="Shivam Chudasama" />
                        </div>
                    </div>
                </div>
                <div className="w-full lg:w-2/3">
                    <p className="text-lg md:text-xl text-slate-600 dark:text-slate-300 leading-relaxed mb-8">
                        {portfolioData.about.description}
                    </p>
                    
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-8">
                        <div className="p-6 bg-white dark:bg-cyber-850 rounded-2xl border border-slate-200 dark:border-cyber-800">
                            <h3 className="text-lg font-bold mb-4 text-slate-800 dark:text-white border-b border-slate-100 dark:border-cyber-800 pb-2">Location</h3>
                            <div className="space-y-2 text-slate-600 dark:text-slate-400">
                                <p className="flex items-center"><MapPinIcon /> {portfolioData.about.contact.location1}</p>
                                <p className="flex items-center"><MapPinIcon /> {portfolioData.about.contact.location2}</p>
                            </div>
                        </div>
                        <div className="p-6 bg-white dark:bg-cyber-850 rounded-2xl border border-slate-200 dark:border-cyber-800">
                            <h3 className="text-lg font-bold mb-4 text-slate-800 dark:text-white border-b border-slate-100 dark:border-cyber-800 pb-2">Contact Details</h3>
                            <div className="space-y-2 text-slate-600 dark:text-slate-400">
                                <p><strong>Email:</strong> <a href={`mailto:${portfolioData.about.contact.email}`} className="text-cyber-primary hover:underline">{portfolioData.about.contact.email}</a></p>
                                <p><strong>Phone:</strong> <span className="hover:text-cyber-primary">{portfolioData.about.contact.phone}</span></p>
                            </div>
                        </div>
                    </div>
                    
                    <div className="flex flex-col sm:flex-row gap-4">
                        <a href={portfolioData.about.resumeUrl} download className="inline-flex items-center justify-center bg-cyber-primary hover:bg-cyber-primary/95 text-white font-bold py-3.5 px-8 rounded-xl shadow-md transition duration-300 transform hover:-translate-y-0.5">
                            <DownloadIcon />
                            Download Resume
                        </a>
                        <a href="#contact" className="inline-flex items-center justify-center bg-transparent border border-slate-300 dark:border-cyber-800 text-slate-700 dark:text-slate-200 hover:bg-slate-100 dark:hover:bg-cyber-800 font-bold py-3.5 px-8 rounded-xl transition duration-300">
                            Get In Touch
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

const ExperienceSection = () => {
    const [activeTab, setActiveTab] = useState('work');

    return (
        <section id="experience" className="py-24 bg-white dark:bg-cyber-950 transition-colors duration-300">
            <div className="container mx-auto px-6 max-w-5xl">
                <h2 className="text-4xl md:text-5xl font-black text-center mb-12 text-slate-800 dark:text-white">
                    Timeline
                </h2>
                
                {/* Tabs */}
                <div className="flex justify-center mb-16">
                    <div className="bg-slate-100 dark:bg-cyber-900 p-1.5 rounded-xl flex gap-1 border border-slate-200 dark:border-cyber-850">
                        <button 
                            onClick={() => setActiveTab('work')} 
                            className={`flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-bold transition ${activeTab === 'work' ? 'bg-cyber-primary text-white shadow-md' : 'text-slate-500 dark:text-slate-400 hover:text-cyber-primary'}`}
                        >
                            <BriefcaseIcon /> Work Experience
                        </button>
                        <button 
                            onClick={() => setActiveTab('education')} 
                            className={`flex items-center gap-2 px-6 py-2.5 rounded-lg text-sm font-bold transition ${activeTab === 'education' ? 'bg-cyber-primary text-white shadow-md' : 'text-slate-500 dark:text-slate-400 hover:text-cyber-primary'}`}
                        >
                            <AcademicCapIcon /> Education
                        </button>
                    </div>
                </div>
                
                {/* Content */}
                <div className="relative border-l-2 border-slate-200 dark:border-cyber-800 pl-8 ml-4 md:ml-6 space-y-12">
                    {activeTab === 'work' ? (
                        portfolioData.resume.work.map((job, index) => (
                            <div key={index} className="relative group">
                                {/* Dot indicator */}
                                <span className="absolute -left-[41px] top-1.5 bg-white dark:bg-cyber-950 border-4 border-cyber-accent w-6 h-6 rounded-full group-hover:scale-125 transition-transform duration-300"></span>
                                
                                <div className="p-6 bg-slate-50 dark:bg-cyber-850 rounded-2xl border border-slate-200 dark:border-cyber-800 shadow-sm hover:shadow-md transition duration-300">
                                    <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
                                        <div>
                                            <h4 className="text-xl font-bold text-slate-800 dark:text-white">{job.title}</h4>
                                            <span className="text-sm font-bold text-cyber-primary uppercase tracking-wide">{job.company}</span>
                                        </div>
                                        <div className="mt-2 md:mt-0 text-slate-500 dark:text-slate-400 text-sm font-semibold flex items-center bg-slate-200/50 dark:bg-cyber-800 px-3 py-1 rounded-lg">
                                            <span>{job.date}</span>
                                            {job.location && (
                                                <>
                                                    <span className="mx-2">&bull;</span>
                                                    <span>{job.location}</span>
                                                </>
                                            )}
                                        </div>
                                    </div>
                                    <p className="text-slate-650 dark:text-slate-350 leading-relaxed text-sm md:text-base">
                                        {job.description}
                                    </p>
                                </div>
                            </div>
                        ))
                    ) : (
                        portfolioData.resume.education.map((edu, index) => (
                            <div key={index} className="relative group">
                                {/* Dot indicator */}
                                <span className="absolute -left-[41px] top-1.5 bg-white dark:bg-cyber-950 border-4 border-cyber-primary w-6 h-6 rounded-full group-hover:scale-125 transition-transform duration-300"></span>
                                
                                <div className="p-6 bg-slate-50 dark:bg-cyber-850 rounded-2xl border border-slate-200 dark:border-cyber-800 shadow-sm hover:shadow-md transition duration-300">
                                    <div className="flex flex-col md:flex-row md:justify-between md:items-center mb-4">
                                        <div>
                                            <h4 className="text-xl font-bold text-slate-800 dark:text-white">{edu.degree}</h4>
                                            <span className="text-sm font-bold text-cyber-secondary uppercase tracking-wide">{edu.university}</span>
                                        </div>
                                        <div className="mt-2 md:mt-0 text-slate-500 dark:text-slate-400 text-sm font-semibold flex items-center bg-slate-200/50 dark:bg-cyber-800 px-3 py-1 rounded-lg">
                                            <span>{edu.date}</span>
                                        </div>
                                    </div>
                                    <p className="text-slate-650 dark:text-slate-350 leading-relaxed text-sm md:text-base">
                                        {edu.description}
                                    </p>
                                </div>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </section>
    );
};

const SkillsSection = () => (
    <section id="skills" className="py-24 bg-slate-50 dark:bg-cyber-900 transition-colors duration-300">
        <div className="container mx-auto px-6">
            <h2 className="text-4xl md:text-5xl font-black text-center mb-16 text-slate-800 dark:text-white">
                Technical Skills
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
                {Object.keys(portfolioData.resume.skills).map((key) => {
                    const category = portfolioData.resume.skills[key];
                    return (
                        <div key={key} className="glow-card bg-white dark:bg-cyber-850 p-6 rounded-2xl border border-slate-200 dark:border-cyber-800 flex flex-col justify-between shadow-sm">
                            <div>
                                <h3 className={`text-lg font-bold mb-4 ${category.textColor} border-b border-slate-100 dark:border-cyber-800 pb-2`}>
                                    {category.title}
                                </h3>
                                <div className="flex flex-wrap gap-2">
                                    {category.items.map((skill) => (
                                        <span key={skill} className="px-3 py-1 rounded-full text-xs font-semibold bg-slate-100 dark:bg-cyber-800 text-slate-650 dark:text-slate-300 border border-slate-200 dark:border-cyber-750 transition hover:border-cyber-primary hover:text-cyber-primary">
                                            {skill}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    </section>
);

const PortfolioSection = ({ onProjectClick }) => {
    const [filter, setFilter] = useState('all');
    
    const categories = [
        { id: 'all', name: 'All' },
        { id: 'robotics', name: 'Robotics & Simulation' },
        { id: 'fullstack', name: 'SaaS & Full Stack' },
        { id: 'mobile', name: 'Android & ML' }
    ];

    const filteredProjects = filter === 'all' 
        ? portfolioData.portfolio 
        : portfolioData.portfolio.filter(p => p.type === filter);

    return (
        <section id="works" className="py-24 bg-white dark:bg-cyber-950 transition-colors duration-300">
            <div className="container mx-auto px-6">
                <h2 className="text-4xl md:text-5xl font-black text-center mb-12 text-slate-800 dark:text-white">
                    Featured Works
                </h2>
                
                {/* Filter Tabs */}
                <div className="flex flex-wrap justify-center gap-2 mb-16">
                    {categories.map((cat) => (
                        <button 
                            key={cat.id} 
                            onClick={() => setFilter(cat.id)}
                            className={`px-6 py-2 rounded-xl text-sm font-bold border transition ${filter === cat.id ? 'bg-cyber-primary border-cyber-primary text-white shadow-md' : 'bg-transparent border-slate-200 dark:border-cyber-800 text-slate-500 dark:text-slate-400 hover:text-cyber-primary hover:border-cyber-primary'}`}
                        >
                            {cat.name}
                        </button>
                    ))}
                </div>

                {/* Projects Grid */}
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
                    {filteredProjects.map((item) => (
                        <div 
                            key={item.id} 
                            className="group relative cursor-pointer overflow-hidden rounded-2xl border border-slate-200 dark:border-cyber-800 bg-white dark:bg-cyber-850 shadow-md hover:shadow-2xl transition duration-500" 
                            onClick={() => onProjectClick(item)}
                        >
                            <div className="overflow-hidden relative h-52">
                                <img src={item.imageUrl} alt={item.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" />
                                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent"></div>
                                <span className="absolute top-4 right-4 px-3 py-1 bg-cyber-accent text-white text-xs font-bold rounded-lg uppercase tracking-wide shadow-md">
                                    {item.category}
                                </span>
                            </div>
                            <div className="p-6">
                                <h3 className="text-xl font-bold text-slate-800 dark:text-white group-hover:text-cyber-primary transition duration-300 mb-2">{item.title}</h3>
                                <div className="flex flex-wrap gap-1.5">
                                    {item.tags.map(tag => (
                                        <span key={tag} className="text-[10px] font-bold tracking-wider px-2 py-0.5 rounded bg-slate-100 dark:bg-cyber-800 text-slate-650 dark:text-slate-300">
                                            {tag}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

const CredentialsSection = () => (
    <section id="credentials" className="py-24 bg-slate-50 dark:bg-cyber-900 transition-colors duration-300">
        <div className="container mx-auto px-6">
            <h2 className="text-4xl md:text-5xl font-black text-center mb-16 text-slate-800 dark:text-white">
                Achievements & Credentials
            </h2>
            
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
                
                {/* Achievements */}
                <div className="p-8 bg-white dark:bg-cyber-850 rounded-2xl border border-slate-200 dark:border-cyber-800 shadow-sm flex flex-col">
                    <div className="flex items-center gap-3 mb-6 border-b border-slate-100 dark:border-cyber-800 pb-4">
                        <span className="p-3 bg-cyber-primary/10 rounded-xl"><AwardIcon /></span>
                        <h3 className="text-2xl font-bold text-slate-800 dark:text-white">Achievements</h3>
                    </div>
                    <div className="flex-1 space-y-6">
                        {portfolioData.achievements.map((item, index) => (
                            <div key={index} className="space-y-2">
                                <h4 className="text-lg font-bold text-slate-800 dark:text-white">{item.title}</h4>
                                <p className="text-sm font-bold text-cyber-primary">{item.event} &bull; <span className="text-slate-450">{item.date}</span></p>
                                <p className="text-sm text-slate-550 dark:text-slate-400">{item.description}</p>
                                {item.link && (
                                    <a href={item.link} target="_blank" rel="noopener noreferrer" className="inline-flex items-center text-xs font-bold text-cyber-primary hover:underline pt-2">
                                        Watch Award Video &rarr;
                                    </a>
                                )}
                            </div>
                        ))}
                    </div>
                </div>

                {/* Certifications */}
                <div className="p-8 bg-white dark:bg-cyber-850 rounded-2xl border border-slate-200 dark:border-cyber-800 shadow-sm flex flex-col">
                    <div className="flex items-center gap-3 mb-6 border-b border-slate-100 dark:border-cyber-800 pb-4">
                        <span className="p-3 bg-cyber-secondary/10 rounded-xl"><ShieldCheckIcon /></span>
                        <h3 className="text-2xl font-bold text-slate-800 dark:text-white">Certifications</h3>
                    </div>
                    <div className="flex-1 space-y-4">
                        {portfolioData.certifications.map((item, index) => (
                            <div key={index} className="p-4 bg-slate-50 dark:bg-cyber-800 rounded-xl border border-slate-150 dark:border-cyber-750 flex items-center justify-between">
                                <div>
                                    <h4 className="text-base font-bold text-slate-800 dark:text-white">{item.title}</h4>
                                    <p className="text-xs font-semibold text-slate-450 dark:text-slate-400">{item.provider}</p>
                                </div>
                                <a href={item.verifyUrl} target="_blank" rel="noopener noreferrer" className="px-3 py-1 bg-cyber-secondary/15 hover:bg-cyber-secondary text-cyber-secondary hover:text-white text-xs font-bold rounded-lg transition">
                                    Verify
                                </a>
                            </div>
                        ))}
                    </div>
                </div>

                {/* Affiliations */}
                <div className="p-8 bg-white dark:bg-cyber-850 rounded-2xl border border-slate-200 dark:border-cyber-800 shadow-sm flex flex-col">
                    <div className="flex items-center gap-3 mb-6 border-b border-slate-100 dark:border-cyber-800 pb-4">
                        <span className="p-3 bg-cyber-accent/10 rounded-xl">
                            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6 text-cyber-accent" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                            </svg>
                        </span>
                        <h3 className="text-2xl font-bold text-slate-800 dark:text-white">Affiliations</h3>
                    </div>
                    <div className="flex-1 space-y-4">
                        {portfolioData.affiliations.map((item, index) => (
                            <div key={index} className="p-4 bg-slate-50 dark:bg-cyber-800 rounded-xl border border-slate-150 dark:border-cyber-750">
                                <h4 className="text-base font-bold text-slate-800 dark:text-white">{item.title}</h4>
                                <p className="text-xs text-cyber-accent font-bold mt-1 uppercase tracking-wide">{item.org}</p>
                            </div>
                        ))}
                    </div>
                </div>
                
            </div>
        </div>
    </section>
);

const TestimonialsSection = () => (
    <section className="py-24 bg-white dark:bg-cyber-950 transition-colors duration-300">
        <div className="container mx-auto px-6 text-center max-w-4xl">
            <h2 className="text-4xl md:text-5xl font-black mb-16 text-slate-800 dark:text-white">Testimonials</h2>
            <div>
                {portfolioData.testimonials.map((testimonial, index) => (
                    <div key={index} className="relative p-10 bg-slate-50 dark:bg-cyber-850 rounded-3xl border border-slate-200 dark:border-cyber-800 shadow-lg">
                        <span className="absolute top-4 left-6 text-6xl text-cyber-primary/20 font-serif leading-none">“</span>
                        <blockquote className="text-lg md:text-xl italic text-slate-650 dark:text-slate-200 mb-8 relative z-10 leading-relaxed">
                            {testimonial.text}
                        </blockquote>
                        <a href={testimonial.link} target="_blank" rel="noopener noreferrer" className="font-bold text-cyber-primary hover:text-cyber-primary/80 transition-colors duration-300 flex items-center justify-center gap-2">
                           - {testimonial.author}
                           <span className="text-xs font-normal underline">(View LinkedIn Recommendation)</span>
                        </a>
                    </div>
                ))}
            </div>
        </div>
    </section>
);

const ContactSection = () => (
    <section id="contact" className="py-24 bg-slate-50 dark:bg-cyber-900 transition-colors duration-300">
        <div className="container mx-auto px-6 text-center max-w-3xl">
            <h2 className="text-4xl md:text-5xl font-black mb-6 text-slate-800 dark:text-white">Get In Touch</h2>
            <p className="text-lg md:text-xl text-slate-505 dark:text-slate-400 mb-12 max-w-2xl mx-auto leading-relaxed">
                I am always open to discussing startup projects, robotics automation work, full stack scaling, or native mobile architecture. Let's create something together.
            </p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-md mx-auto">
                <a href={`mailto:${portfolioData.contact.email}`} className="flex items-center justify-center gap-3 p-4 bg-white dark:bg-cyber-850 border border-slate-200 dark:border-cyber-800 rounded-xl hover:border-cyber-primary hover:shadow-lg transition duration-300 text-slate-700 dark:text-slate-200 font-semibold">
                    <svg className="w-5 h-5 text-cyber-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/></svg>
                    Email Me
                </a>
                <a href={portfolioData.contact.whatsapp} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-3 p-4 bg-white dark:bg-cyber-850 border border-slate-200 dark:border-cyber-800 rounded-xl hover:border-cyber-primary hover:shadow-lg transition duration-300 text-slate-700 dark:text-slate-200 font-semibold">
                    <WhatsappIcon />
                    WhatsApp Me
                </a>
            </div>
        </div>
    </section>
);

const Footer = () => (
    <footer className="bg-slate-100 dark:bg-cyber-950 text-slate-500 dark:text-slate-400 py-12 border-t border-slate-200 dark:border-cyber-800 transition-colors duration-300">
        <div className="container mx-auto px-6 text-center">
             <div className="flex justify-center space-x-6 mb-6">
                <a href={portfolioData.social.linkedin} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-cyber-primary transition"><LinkedinIcon /></a>
                <a href={portfolioData.social.github} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-cyber-primary transition"><GithubIcon /></a>
                <a href={portfolioData.social.youtube} target="_blank" rel="noopener noreferrer" className="text-slate-400 hover:text-cyber-primary transition"><YouTubeIcon /></a>
            </div>
            <p className="text-sm font-semibold mb-2">&copy; {new Date().getFullYear()} Shivam Chudasama. All rights reserved.</p>
            <p className="text-xs text-slate-450 dark:text-slate-500">Built using React, Tailwind CSS and custom SVG components.</p>
        </div>
    </footer>
);

const ScrollToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    const toggleVisibility = () => {
        if (window.pageYOffset > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
    };

    useEffect(() => {
        window.addEventListener("scroll", toggleVisibility);
        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    return (
        <button
            type="button"
            onClick={scrollToTop}
            className={`fixed bottom-6 right-6 p-3.5 rounded-xl bg-cyber-primary hover:bg-cyber-primary/95 text-white shadow-lg shadow-cyber-primary/20 hover:shadow-cyber-primary/35 transition duration-300 transform hover:-translate-y-0.5 z-40 ${isVisible ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
        >
            <ChevronUpIcon />
        </button>
    );
};

const PortfolioModal = ({ item, onClose, onNavigate }) => {
    if (!item) return null;

    const renderMedia = () => {
        if (item.modal.videos) {
            return (
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6">
                    {item.modal.videos.map((vid, idx) => (
                        <div key={idx} className="flex flex-col items-center bg-slate-50 dark:bg-cyber-900 p-4 rounded-2xl border border-slate-200 dark:border-cyber-800">
                            <h4 className="text-sm font-bold text-slate-750 dark:text-slate-350 mb-3">{vid.title}</h4>
                            <div className="relative w-full aspect-[9/16] max-w-[220px] rounded-xl overflow-hidden shadow-md border border-slate-200 dark:border-cyber-750">
                                <iframe 
                                    className="absolute top-0 left-0 w-full h-full"
                                    src={vid.src}
                                    title={vid.title}
                                    frameBorder="0" 
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                    allowFullScreen>
                                </iframe>
                            </div>
                        </div>
                    ))}
                </div>
            );
        }
        if (item.modal.video) {
            if (item.modal.video.type === 'youtube') {
                return (
                    <div className="relative w-full mb-6 rounded-2xl overflow-hidden shadow-inner border border-slate-200 dark:border-cyber-800" style={{paddingTop: '56.25%'}}>
                        <iframe 
                            className="absolute top-0 left-0 w-full h-full"
                            src={item.modal.video.src}
                            title="YouTube video player" 
                            frameBorder="0" 
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                            allowFullScreen>
                        </iframe>
                    </div>
                );
            } else {
                return (
                     <div className="relative w-full mb-6 rounded-2xl overflow-hidden shadow-inner border border-slate-200 dark:border-cyber-800" style={{paddingTop: '56.25%'}}>
                        <video 
                            className="absolute top-0 left-0 w-full h-full"
                            src={item.modal.video.src} 
                            type={item.modal.video.type}
                            controls 
                            autoPlay
                            preload="auto">
                            Your browser does not support the video tag.
                        </video>
                    </div>
                );
            }
        }
        if (item.modal.images) {
            return item.modal.images.map((img, index) => 
                <div key={index} className="rounded-2xl overflow-hidden mb-6 border border-slate-200 dark:border-cyber-800 shadow-md">
                    <img src={img} alt={`${item.modal.title} screenshot ${index + 1}`} className="w-full h-auto object-cover"/>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="fixed inset-0 bg-slate-900/80 dark:bg-cyber-950/90 flex items-center justify-center z-50 p-4 backdrop-blur-sm" onClick={onClose}>
             <button 
                onClick={(e) => { e.stopPropagation(); onNavigate('prev'); }} 
                className="absolute left-2 md:left-6 top-1/2 -translate-y-1/2 z-50 text-slate-800 dark:text-white bg-white/70 dark:bg-cyber-850/50 p-3 rounded-xl hover:bg-white dark:hover:bg-cyber-800 transition shadow-lg backdrop-blur-sm border border-slate-200 dark:border-cyber-700"
            >
                <ChevronLeftIcon />
            </button>
            <div className="bg-white dark:bg-cyber-850 rounded-3xl shadow-2xl max-w-4xl w-full max-h-[90vh] overflow-y-auto border border-slate-200/50 dark:border-cyber-800" onClick={e => e.stopPropagation()}>
                <div className="p-6 md:p-8">
                    {renderMedia()}
                    <div className="flex flex-wrap items-center justify-between gap-4 mb-4">
                        <h3 className="text-2xl md:text-3xl font-black text-slate-850 dark:text-white">{item.modal.title}</h3>
                        <span className="px-3.5 py-1 bg-cyber-primary/10 border border-cyber-primary/30 text-cyber-primary text-xs font-bold rounded-lg uppercase tracking-wide">
                            {item.category}
                        </span>
                    </div>
                    
                    <p className="text-slate-650 dark:text-slate-300 leading-relaxed text-base mb-8">
                        {item.modal.description}
                    </p>
                    
                    <div className="flex justify-between items-center border-t border-slate-100 dark:border-cyber-800 pt-6">
                        {item.modal.link ? (
                            <a href={item.modal.link} target="_blank" rel="noopener noreferrer" className="bg-cyber-primary hover:bg-cyber-primary/95 text-white font-bold py-2.5 px-6 rounded-xl transition shadow-md shadow-cyber-primary/15">
                                View Project Link
                            </a>
                        ) : <div />}
                        <button onClick={onClose} className="bg-slate-100 hover:bg-slate-200 text-slate-700 font-bold py-2.5 px-6 rounded-xl transition dark:bg-cyber-800 dark:hover:bg-cyber-750 dark:text-white">
                            Close
                        </button>
                    </div>
                </div>
            </div>
            <button 
                onClick={(e) => { e.stopPropagation(); onNavigate('next'); }} 
                className="absolute right-2 md:right-6 top-1/2 -translate-y-1/2 z-50 text-slate-800 dark:text-white bg-white/70 dark:bg-cyber-850/50 p-3 rounded-xl hover:bg-white dark:hover:bg-cyber-800 transition shadow-lg backdrop-blur-sm border border-slate-200 dark:border-cyber-700"
            >
                <ChevronRightIcon />
            </button>
        </div>
    );
};

// Preservation of custom Chatbase chatbot logic
const ChatbaseChatbot = () => {
    useEffect(() => {
        if (document.getElementById('1fyB3MxPimvg9RobNU-9y')) {
            return;
        }
        const script = document.createElement('script');
        script.src = 'https://www.chatbase.co/embed.min.js';
        script.id = '1fyB3MxPimvg9RobNU-9y'; 
        script.setAttribute('domain', 'www.chatbase.co');
        script.defer = true;
        document.body.appendChild(script);

        return () => {
            const existingScript = document.getElementById('1fyB3MxPimvg9RobNU-9y');
            if (existingScript) {
                document.body.removeChild(existingScript);
            }
        };
    }, []);
    return null;
};

// ==========================================
// 4. MAIN APP CONTAINER
// ==========================================

export default function App() {
    const [currentPage, setCurrentPage] = useState('home');
    const [selectedProject, setSelectedProject] = useState(null);
    const [darkMode, setDarkMode] = useState(true);

    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [darkMode]);

    const scrollTo = (id) => {
        const element = document.getElementById(id);
        if (element) {
            element.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
            });
        }
    };

    const handleNavClick = (pageId) => {
        if (pageId.startsWith('video_')) {
            const project = portfolioData.portfolio.find(p => p.modal && p.modal.videoPage === `${pageId}.html`);
            if (project) {
                setSelectedProject(project);
            }
        } else {
            scrollTo(pageId);
            setCurrentPage(pageId);
        }
    };

    const handleProjectClick = (project) => {
        setSelectedProject(project);
    };

    const handleProjectNavigation = (direction) => {
        if (!selectedProject) return;
        const currentIndex = portfolioData.portfolio.findIndex(p => p.id === selectedProject.id);
        const totalItems = portfolioData.portfolio.length;
        let nextIndex;

        if (direction === 'next') {
            nextIndex = (currentIndex + 1) % totalItems;
        } else {
            nextIndex = (currentIndex - 1 + totalItems) % totalItems;
        }
        
        setSelectedProject(portfolioData.portfolio[nextIndex]);
    };

    return (
        <div className="bg-slate-50 dark:bg-cyber-950 font-sans leading-normal tracking-normal transition-colors duration-300 min-h-screen">
            <Header onNavClick={handleNavClick} page={currentPage} darkMode={darkMode} setDarkMode={setDarkMode} />
            <main>
                <HeroSection onNavClick={handleNavClick} />
                <AboutSection />
                <ExperienceSection />
                <SkillsSection />
                <PortfolioSection onProjectClick={handleProjectClick} />
                <CredentialsSection />
                <TestimonialsSection />
                <ContactSection />
            </main>
            <Footer />
            <ScrollToTopButton />
            <PortfolioModal 
                item={selectedProject} 
                onClose={() => setSelectedProject(null)} 
                onNavigate={handleProjectNavigation}
            />  
            <ChatbaseChatbot />
        </div>
    );
}
